import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'

import { useDarkMode } from '../DarkMode/hook'
import pageNotFoundlogoDarkMode from '~/images/error/404-dark.svg'
import pageNotFoundLogo from '~/images/error/404.svg'

export default function PageNotFound() {
  
  const { isDark } = useDarkMode()
  const { t } = useTranslation()
  const isHydrated = useHydrated()

  return (
    <div className="flex flex-col h-screen sm:bg-neutral-00 lg:bg-neutral-05 dark:bg-neutral-98 px-[24px] pt-[80px]">
      <section className="absolute flex justify-center translate-x-1/2 -translate-y-1/2 top-1/2 right-1/2">
        <div className="flex sm:flex-col sm:gap-[32px] lg:flex-row md:gap-[80px] rounded-md py-6 px-16 bg-white dark:sm:bg-transparent lg:dark:bg-neutral-95">
          <div className="flex flex-col sm:gap-[16px] md:gap-[20px] lg:gap-0 justify-center lg:w-[335px] sm:text-center lg:text-left">
            <p className="text-neutral-50 dark:text-neutral-50 sm:text-[36px] leading-[42px] lg:text-[43px] lg:leading-[54px]">
              {t('components.ui.404.oops')}
            </p>
            <p className="text-neutral-95 dark:text-neutral-20 sm:text-h3 md:text-h1 lg:text-[43px] lg:leading-[54px]">
              {t('components.ui.404.message')}
            </p>
          </div>
          {isHydrated && <img
            src={isDark() ? pageNotFoundlogoDarkMode : pageNotFoundLogo}
            alt="404"
            className="sm:max-w-[260px] sm:h-[236px] md:max-w-[372px] md:h-[311px]"
          />}
        </div>
      </section>
    </div>
  )
}